module.exports = __webpack_public_path__ + "img/6f0be0488c7d3ef239ba11d2cd799576.png";